import { defaultFilterProcesor } from './default';
import { rangeFilterProcessor } from './range';
import { treeFilterProcessor } from './tree';
import { linkFilterProcessor } from './link';
import { selectFilterProcessor } from './select';
import { textFilterProcessor } from './text';

export const filterTypeProcessors = {
	'default': defaultFilterProcesor,
	'range': rangeFilterProcessor,
	'tree': treeFilterProcessor,
	'link': linkFilterProcessor,
	'select': selectFilterProcessor,
	'text': textFilterProcessor,
}

export default filterTypeProcessors;